<template>
  <div class="honorarios">
    <div class="page-header">
      <h1></h1>
      <button @click="showModal = true" class="btn btn-success">
        <i class="fas fa-plus"></i> Novo Honorario
      </button>
    </div>

    <div class="filters">
      <div class="form-group">
        <label for="filtroStatus">Filtrar por Status:</label>
        <select id="filtroStatus" v-model="filtroStatus">
          <option value="">Todos</option>
          <option value="Pendente">Pendente</option>
          <option value="Recebido">Recebido</option>
        </select>
      </div>

      <div class="form-group">
        <label for="filtroArea">�rea Juridica:</label>
        <select id="filtroArea" v-model="filtroArea">
          <option value="">Todas</option>
          <option value="Civil">Civil</option>
          <option value="Trabalhista">Trabalhista</option>
          <option value="Criminal">Criminal</option>
          <option value="Empresarial">Empresarial</option>
          <option value="Fam�lia">Familia</option>
          <option value="Tribut�rio">Tributario</option>
        </select>
      </div>

      <label class="toggle-filter">
        <input v-model="somenteAtrasados" type="checkbox">
        <span>Somente com parcelas em atraso</span>
      </label>
    </div>

    <div class="table-container">
      <table class="table">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>N� Processo</th>
            <th>�rea Juridica</th>
            <th>Valor Total</th>
            <th>Recebido</th>
            <th>Parcelas</th>
            <th>Proximo Vencimento</th>
            <th>Status</th>
            <th>A��es</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in honorariosPaginados" :key="item.honorario.id">
            <tr>
              <td>{{ item.customerName }}</td>
              <td>{{ item.honorario.processNumber }}</td>
              <td>{{ item.honorario.legalArea }}</td>
              <td>{{ formatCurrency(item.honorario.value) }}</td>
              <td>{{ formatCurrency(item.honorario.paidValue) }}</td>
              <td>
                <div class="installment-summary">
                  <strong>{{ item.installmentText }}</strong>
                  <span v-if="item.overdueCount > 0" class="installment-meta overdue">
                    {{ item.overdueCount }} em atraso
                  </span>
                </div>
              </td>
              <td>{{ item.nextPendingLabel }}</td>
              <td>
                <span :class="['status-badge', item.summary.status.toLowerCase()]">
                  {{ item.summary.status }}
                </span>
              </td>
              <td class="actions-cell">
                <button
                  v-if="item.summary.status === 'Pendente'"
                  @click="marcarHonorarioComoRecebido(item)"
                  class="btn-action paid"
                  title="Marcar tudo como Recebido"
                >
                  <i class="fas fa-check"></i>
                </button>
                <button
                  v-if="item.summary.status === 'Recebido'"
                  @click="marcarHonorarioComoPendente(item)"
                  class="btn-action pending"
                  title="Marcar tudo como Pendente"
                >
                  <i class="fas fa-undo"></i>
                </button>
                <button
                  @click="toggleParcelas(item.honorario.id)"
                  class="btn-action info"
                  :title="isExpanded(item.honorario.id) ? 'Ocultar parcelas' : 'Ver parcelas'"
                >
                  <i :class="isExpanded(item.honorario.id) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                </button>
                <button
                  @click="abrirDeleteModal(item.honorario.id)"
                  class="btn-action delete"
                  title="Deletar"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>

            <tr v-if="isExpanded(item.honorario.id)" class="details-row">
              <td colspan="9">
                <div class="details-panel">
                  <div class="details-summary">
                    <article class="mini-card">
                      <span>Total</span>
                      <strong>{{ item.installments.length }} parcela(s)</strong>
                    </article>
                    <article class="mini-card">
                      <span>Pagas</span>
                      <strong>{{ item.summary.paidCount }}</strong>
                    </article>
                    <article class="mini-card">
                      <span>Pendentes</span>
                      <strong>{{ item.summary.pendingCount }}</strong>
                    </article>
                    <article class="mini-card warning" v-if="item.overdueCount > 0">
                      <span>Em atraso</span>
                      <strong>{{ item.overdueCount }}</strong>
                    </article>
                  </div>

                  <div class="installments-grid">
                    <article
                      v-for="installment in item.installments"
                      :key="installment.id"
                      class="installment-card"
                      :class="{ paid: installment.status === 'Recebido', overdue: installment.isOverdue }"
                    >
                      <div class="installment-head">
                        <div>
                          <p class="installment-title">Parcela {{ installment.label }}</p>
                          <p class="installment-date">Vencimento {{ installment.dueDateLabel }}</p>
                        </div>
                        <span :class="['status-badge', installment.status.toLowerCase()]">
                          {{ installment.status }}
                        </span>
                      </div>

                      <div class="installment-values">
                        <div>
                          <span>Valor</span>
                          <strong>{{ formatCurrency(installment.value) }}</strong>
                        </div>
                        <div>
                          <span>Recebido</span>
                          <strong>{{ formatCurrency(installment.paidValue) }}</strong>
                        </div>
                        <div>
                          <span>A receber</span>
                          <strong>{{ formatCurrency(Math.max(installment.value - installment.paidValue, 0)) }}</strong>
                        </div>
                      </div>

                      <p v-if="installment.isOverdue" class="installment-warning">
                        Parcela vencida e ainda pendente.
                      </p>

                      <button
                        type="button"
                        class="btn"
                        :class="installment.status === 'Recebido' ? 'btn-secondary' : 'btn-success'"
                        @click="alternarParcela(item, installment.installmentNumber)"
                      >
                        {{ installment.status === 'Recebido' ? 'Reabrir parcela' : 'Dar baixa na parcela' }}
                      </button>
                    </article>
                  </div>
                </div>
              </td>
            </tr>
          </template>

          <tr v-if="honorariosFiltrados.length === 0 && !loading">
            <td colspan="9" class="no-data">Nenhum honorario encontrado</td>
          </tr>
          <tr v-if="loading">
            <td colspan="9" class="no-data">Carregando...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <PaginationControls
      v-model:current-page="paginaAtual"
      v-model:items-per-page="itensPorPagina"
      :total-items="honorariosFiltrados.length"
      :total-pages="totalPaginas"
      :disabled="loading"
    />

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h2>Cadastrar Novo Honorario</h2>

        <form @submit.prevent="salvarHonorario">
          <div class="form-group">
            <label for="cliente">Cliente *</label>
            <div class="autocomplete-container">
              <input
                id="cliente"
                v-model="buscarCliente"
                type="text"
                @input="handleClienteInput"
                @focus="mostrarSugestoes = true"
                placeholder="Digite o nome do cliente..."
                required
              >
              <div v-if="mostrarSugestoes && clientesFiltrados.length > 0" class="suggestions">
                <div
                  v-for="cliente in clientesFiltrados"
                  :key="cliente.id"
                  @click="selecionarCliente(cliente)"
                  class="suggestion-item"
                >
                  {{ cliente.fullName }}
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="processNumber">Nr Processo *</label>
            <input
              id="processNumber"
              :value="novoHonorario.processNumber"
              type="text"
              placeholder="1234567-89.2024.8.26.0100"
              maxlength="25"
              @input="formatarNumeroProcessoInput"
              :disabled="!canEditProcessNumber"
              required
            >
          </div>

          <div class="form-group">
            <label for="legalArea">Area Juridica *</label>
            <select id="legalArea" v-model="novoHonorario.legalArea" :disabled="!canEditLegalArea" required>
              <option disabled value="">Selecione</option>
              <option value="Civil">Civil</option>
              <option value="Trabalhista">Trabalhista</option>
              <option value="Criminal">Criminal</option>
              <option value="Empresarial">Empresarial</option>
              <option value="Fam�lia">Familia</option>
              <option value="Tribut�rio">Tributario</option>
            </select>
          </div>

          <div class="form-group">
            <label for="valor">Valor (R$) *</label>
            <input
              id="valor"
              :value="valorFormatado"
              type="text"
              inputmode="decimal"
              placeholder="R$ 0,00"
              @input="formatarValorInput"
              :disabled="!canEditValue"
              required
            >
          </div>

          <div class="form-group">
            <label for="paidValue">Valor Pago (R$)</label>
            <input
              id="paidValue"
              :value="valorPagoFormatado"
              type="text"
              inputmode="decimal"
              placeholder="R$ 0,00"
              @input="formatarValorPagoInput"
              :disabled="!canEditPaidValue"
            >
          </div>

          <div class="form-group">
            <label for="date">Data Base *</label>
            <input id="date" v-model="novoHonorario.date" type="date" :disabled="!canEditDate" required>
          </div>

          <div class="form-group">
            <label for="paymentMethod">Forma de Pagamento *</label>
            <select
              id="paymentMethod"
              v-model="novoHonorario.paymentMethod"
              @change="ajustarParcelas"
              :disabled="!canEditPaymentMethod"
              required
            >
              <option disabled value="">Selecione</option>
              <option value="Dinheiro">Dinheiro</option>
              <option value="Pix">Pix</option>
              <option value="D�bito">Debito</option>
              <option value="Cr�dito">Credito</option>
            </select>
          </div>

          <div class="form-group" v-if="isCreditSelected">
            <label for="installments">Parcelas</label>
            <select id="installments" v-model.number="novoHonorario.installments" :disabled="!canEditInstallments">
              <option v-for="parcela in parcelasDisponiveis" :key="parcela" :value="parcela">
                {{ parcela }}x
              </option>
            </select>
          </div>

          <div class="form-group">
            <label for="status">Status *</label>
            <select id="status" v-model="novoHonorario.status" :disabled="isStatusLocked || !canEditStatus" required>
              <option v-if="!isImmediatePayment" value="Pendente">Pendente</option>
              <option v-if="!isCreditSelected" value="Recebido">Recebido</option>
            </select>
            <small v-if="isCreditSelected" class="field-help">
              Honorarios em Credito devem iniciar como pendentes para permitir o controle das parcelas.
            </small>
            <small v-else-if="isImmediatePayment" class="field-help">
              Pagamentos em Pix e Debito entram direto como recebidos.
            </small>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn btn-success" :disabled="!formularioCompleto">
              <i class="fas fa-save"></i> Salvar
            </button>
            <button type="button" class="btn btn-secondary" @click="cancelar">
              <i class="fas fa-times"></i> Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="showDeleteModal" class="modal" @click.self="fecharDeleteModal">
      <div class="modal-content notice-modal">
        <h2>Confirmar exclusao</h2>
        <p>Tem certeza que deseja deletar este honorario?</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" @click="fecharDeleteModal">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="confirmarDeleteHonorario">
            Deletar
          </button>
        </div>
      </div>
    </div>

    <div v-if="showNoticeModal" class="modal" @click.self="fecharNoticeModal">
      <div class="modal-content notice-modal">
        <h2>Aviso</h2>
        <p>{{ noticeMessage }}</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-primary" @click="fecharNoticeModal">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import type { Customer, Honorary } from '@/types'
import PaginationControls from '@/components/PaginationControls.vue'
import {
  buildHonoraryInstallmentUpdate,
  clearPaidInstallments,
  setUpfrontPaidValue,
  isCreditPaymentMethod,
  setPaidInstallments,
  summarizeHonoraryInstallments,
  type HonoraryInstallment
} from '@/utils/installments'

type InstallmentView = HonoraryInstallment & {
  dueDateLabel: string
  dueDateTimestamp: number
  isOverdue: boolean
}

type HonorarioRow = {
  honorario: Honorary
  customerName: string
  installments: InstallmentView[]
  summary: ReturnType<typeof summarizeHonoraryInstallments>['summary']
  overdueCount: number
  installmentText: string
  nextPendingLabel: string
}

export default defineComponent({
  name: 'Honorarios',
  components: {
    PaginationControls
  },
  setup() {
    const store = useStore()
    const showModal = ref(false)
    const showDeleteModal = ref(false)
    const showNoticeModal = ref(false)
    const noticeMessage = ref('')
    const honorarioParaDeletar = ref<string | null>(null)
    const expandedHonorarios = ref<string[]>([])
    const filtroStatus = ref('')
    const filtroArea = ref('')
    const somenteAtrasados = ref(false)
    const paginaAtual = ref(1)
    const itensPorPagina = ref(10)
    const buscarCliente = ref('')
    const mostrarSugestoes = ref(false)
    const clientesFiltrados = ref<Customer[]>([])
    const parcelasDisponiveis = Array.from({ length: 12 }, (_, index) => index + 1)
    const valorFormatado = ref('')
    const valorPagoFormatado = ref('')

    const novoHonorario = ref({
      customerId: '',
      processNumber: '',
      legalArea: '' as Honorary['legalArea'] | '',
      value: 0,
      paidValue: 0,
      date: new Date().toISOString().split('T')[0],
      paymentMethod: '' as Honorary['paymentMethod'] | '',
      installments: null as number | null,
      status: 'Pendente' as Honorary['status']
    })

    const clientes = computed<Customer[]>(() => store.state.clientes as Customer[])
    const honorarios = computed<Honorary[]>(() => store.state.honorarios as Honorary[])
    const loading = computed(() => store.state.loading)
    const isCreditSelected = computed(() => isCreditPaymentMethod(novoHonorario.value.paymentMethod || ''))
    const isImmediatePayment = computed(() => ['Pix', 'D�bito', 'Debito'].includes(novoHonorario.value.paymentMethod || ''))
    const isInstallmentLocked = computed(() =>
      isCreditSelected.value && Math.max(novoHonorario.value.installments || 0, 0) > 1
    )
    const isStatusLocked = computed(() => isCreditSelected.value || isImmediatePayment.value)
    const canEditProcessNumber = computed(() => !!novoHonorario.value.customerId)
    const canEditLegalArea = computed(() => canEditProcessNumber.value && isProcessNumberComplete.value)
    const canEditValue = computed(() => canEditLegalArea.value && !!novoHonorario.value.legalArea)
    const canEditPaidValue = computed(() => canEditValue.value && novoHonorario.value.value > 0)
    const canEditDate = computed(() => canEditPaidValue.value)
    const canEditPaymentMethod = computed(() => canEditDate.value && !!novoHonorario.value.date)
    const canEditInstallments = computed(() => canEditPaymentMethod.value && isCreditSelected.value)
    const canEditStatus = computed(() => {
      if (!canEditPaymentMethod.value || !novoHonorario.value.paymentMethod) {
        return false
      }

      if (isCreditSelected.value) {
        return Math.max(novoHonorario.value.installments || 0, 0) >= 1
      }

      return true
    })
    const processNumberDigits = computed(() => novoHonorario.value.processNumber.replace(/\D/g, ''))
    const isProcessNumberComplete = computed(() => /^\d{7}-\d{2}\.\d{4}\.\d\.\d{2}\.\d{4}$/.test(novoHonorario.value.processNumber))
    const formularioCompleto = computed(() => {
      const hasCliente = !!novoHonorario.value.customerId && buscarCliente.value.trim().length > 0
      const hasProcesso = isProcessNumberComplete.value
      const hasArea = !!novoHonorario.value.legalArea
      const hasValor = novoHonorario.value.value > 0
      const hasData = !!novoHonorario.value.date
      const hasFormaPagamento = !!novoHonorario.value.paymentMethod
      const hasStatus = !!novoHonorario.value.status
      const hasParcelas = !isCreditSelected.value || Math.max(novoHonorario.value.installments || 0, 0) >= 1

      return hasCliente && hasProcesso && hasArea && hasValor && hasData && hasFormaPagamento && hasStatus && hasParcelas
    })

    const abrirNoticeModal = (message: string) => {
      noticeMessage.value = message
      showNoticeModal.value = true
    }

    const fecharNoticeModal = () => {
      showNoticeModal.value = false
      noticeMessage.value = ''
    }

    const parseDate = (dateValue: string | Date) => {
      const parsedDate = new Date(dateValue)
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
    }

    const startOfDay = (date: Date) => {
      const normalizedDate = new Date(date)
      normalizedDate.setHours(0, 0, 0, 0)
      return normalizedDate
    }

    const formatCurrency = (value: number) => value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })

    const parseCurrencyInput = (value: string) => {
      const digits = value.replace(/\D/g, '')
      return Number(digits || '0') / 100
    }

    const normalizeErrorMessage = (message: string) =>
      message
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    const formatProcessNumber = (value: string) => {
      const digits = value.replace(/\D/g, '').slice(0, 20)
      const parts = [
        digits.slice(0, 7),
        digits.slice(7, 9),
        digits.slice(9, 13),
        digits.slice(13, 14),
        digits.slice(14, 16),
        digits.slice(16, 20)
      ].filter(Boolean)

      let formatted = ''

      if (parts[0]) formatted += parts[0]
      if (parts[1]) formatted += `-${parts[1]}`
      if (parts[2]) formatted += `.${parts[2]}`
      if (parts[3]) formatted += `.${parts[3]}`
      if (parts[4]) formatted += `.${parts[4]}`
      if (parts[5]) formatted += `.${parts[5]}`

      return formatted
    }

    const formatarNumeroProcessoInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      novoHonorario.value.processNumber = formatProcessNumber(target.value)
    }

    const formatarValorInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      const parsedValue = parseCurrencyInput(target.value)
      novoHonorario.value.value = parsedValue
      valorFormatado.value = parsedValue ? formatCurrency(parsedValue) : ''
    }

    const formatarValorPagoInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      const parsedValue = parseCurrencyInput(target.value)
      novoHonorario.value.paidValue = parsedValue
      valorPagoFormatado.value = parsedValue ? formatCurrency(parsedValue) : ''
    }

    const getClienteName = (customerId: string) => {
      return clientes.value.find((cliente) => cliente.id === customerId)?.fullName || 'Cliente nao encontrado'
    }

    const honorarioRows = computed<HonorarioRow[]>(() => {
      const today = startOfDay(new Date()).getTime()

      return honorarios.value.map((honorario) => {
        const { installments: rawInstallments, summary } = summarizeHonoraryInstallments(honorario)
        const installments = rawInstallments
          .map<InstallmentView>((installment) => {
            const dueDate = parseDate(installment.dueDate) || new Date()
            const dueDateTimestamp = startOfDay(dueDate).getTime()

            return {
              ...installment,
              dueDateLabel: dueDate.toLocaleDateString('pt-BR'),
              dueDateTimestamp,
              isOverdue: installment.status === 'Pendente' && dueDateTimestamp < today
            }
          })
          .sort((a, b) => a.installmentNumber - b.installmentNumber)

        const nextPendingInstallment = installments.find((installment) => installment.status === 'Pendente')

        return {
          honorario,
          customerName: getClienteName(honorario.customerId),
          installments,
          summary,
          overdueCount: installments.filter((installment) => installment.isOverdue).length,
          installmentText: installments.length > 1
            ? `${summary.paidCount}/${installments.length} pagas`
            : `${installments.length} unica`,
          nextPendingLabel: nextPendingInstallment ? nextPendingInstallment.dueDateLabel : 'Tudo recebido'
        }
      })
    })

    const honorariosFiltrados = computed(() => {
      return honorarioRows.value.filter((item) => {
        if (filtroStatus.value && item.summary.status !== filtroStatus.value) {
          return false
        }

        if (filtroArea.value && item.honorario.legalArea !== filtroArea.value) {
          return false
        }

        if (somenteAtrasados.value && item.overdueCount === 0) {
          return false
        }

        return true
      })
    })
    const totalPaginas = computed(() => Math.max(Math.ceil(honorariosFiltrados.value.length / itensPorPagina.value), 1))
    const honorariosPaginados = computed(() => {
      const start = (paginaAtual.value - 1) * itensPorPagina.value
      return honorariosFiltrados.value.slice(start, start + itensPorPagina.value)
    })

    const isExpanded = (honorarioId: string) => expandedHonorarios.value.includes(honorarioId)

    const toggleParcelas = (honorarioId: string) => {
      if (isExpanded(honorarioId)) {
        expandedHonorarios.value = expandedHonorarios.value.filter((id) => id !== honorarioId)
        return
      }

      expandedHonorarios.value = [...expandedHonorarios.value, honorarioId]
    }

    const syncInstallments = async (honorario: Honorary, paidInstallments: number[]) => {
      const updateData = buildHonoraryInstallmentUpdate(honorario, paidInstallments)

      try {
        await store.dispatch('atualizarHonorario', {
          id: honorario.id,
          data: updateData
        })

        if (paidInstallments.length > 0) {
          setPaidInstallments(honorario.id, paidInstallments)
        } else {
          clearPaidInstallments(honorario.id)
        }

        await store.dispatch('loadHonorarios')
      } catch (error: any) {
        abrirNoticeModal(error.message || 'Erro ao atualizar parcelas')
      }
    }

    const alternarParcela = async (item: HonorarioRow, installmentNumber: number) => {
      const currentInstallment = item.installments.find((installment) => installment.installmentNumber === installmentNumber)

      if (!currentInstallment) {
        return
      }

      const paidInstallments = new Set(item.summary.paidInstallments)

      if (currentInstallment.status === 'Recebido') {
        paidInstallments.delete(installmentNumber)
      } else {
        paidInstallments.add(installmentNumber)
      }

      await syncInstallments(item.honorario, [...paidInstallments])
    }

    const marcarHonorarioComoRecebido = async (item: HonorarioRow) => {
      const paidInstallments = item.installments.map((installment) => installment.installmentNumber)
      await syncInstallments(item.honorario, paidInstallments)
    }

    const marcarHonorarioComoPendente = async (item: HonorarioRow) => {
      await syncInstallments(item.honorario, [])
    }

    const filtrarClientes = () => {
      if (!buscarCliente.value.trim()) {
        clientesFiltrados.value = []
        mostrarSugestoes.value = false
        return
      }

      const termo = buscarCliente.value.toLowerCase()
      clientesFiltrados.value = clientes.value.filter((cliente) => cliente.fullName.toLowerCase().includes(termo))
      mostrarSugestoes.value = true
    }

    const handleClienteInput = () => {
      novoHonorario.value.customerId = ''
      filtrarClientes()
    }

    const selecionarCliente = (cliente: Customer) => {
      buscarCliente.value = cliente.fullName
      novoHonorario.value.customerId = cliente.id
      mostrarSugestoes.value = false
    }

    const ajustarParcelas = () => {
      if (isImmediatePayment.value) {
        novoHonorario.value.status = 'Recebido'
      }

      if (isCreditSelected.value) {
        novoHonorario.value.status = 'Pendente'
      }

      if (!isCreditPaymentMethod(novoHonorario.value.paymentMethod || '')) {
        novoHonorario.value.installments = null
        return
      }

      if (!novoHonorario.value.installments) {
        novoHonorario.value.installments = 1
      }

      if (Math.max(novoHonorario.value.installments || 0, 0) > 1) {
        novoHonorario.value.status = 'Pendente'
      }
    }

    const resetForm = () => {
      novoHonorario.value = {
        customerId: '',
        processNumber: '',
        legalArea: '' as Honorary['legalArea'] | '',
        value: 0,
        paidValue: 0,
        date: new Date().toISOString().split('T')[0],
        paymentMethod: '' as Honorary['paymentMethod'] | '',
        installments: null,
        status: 'Pendente'
      }
      valorFormatado.value = ''
      valorPagoFormatado.value = ''
      buscarCliente.value = ''
      clientesFiltrados.value = []
      mostrarSugestoes.value = false
    }

    const cancelar = () => {
      resetForm()
      showModal.value = false
    }

    const salvarHonorario = async () => {
      try {
        if (!novoHonorario.value.customerId) {
          abrirNoticeModal('Selecione um cliente na lista antes de salvar.')
          return
        }

        if (!novoHonorario.value.processNumber.trim()) {
          abrirNoticeModal('Informe o numero do processo.')
          return
        }

        if (!isProcessNumberComplete.value || processNumberDigits.value.length !== 20) {
          abrirNoticeModal('Informe o numero do processo no padrao CNJ com 20 digitos.')
          return
        }

        if (!novoHonorario.value.legalArea) {
          abrirNoticeModal('Selecione a area juridica.')
          return
        }

        if (!novoHonorario.value.value || novoHonorario.value.value <= 0) {
          abrirNoticeModal('Informe um valor valido para o honorario.')
          return
        }

        if (!novoHonorario.value.date) {
          abrirNoticeModal('Informe a data base do honorario.')
          return
        }

        if (!novoHonorario.value.paymentMethod) {
          abrirNoticeModal('Selecione a forma de pagamento.')
          return
        }

        if (isCreditPaymentMethod(novoHonorario.value.paymentMethod || '') && !novoHonorario.value.installments) {
          abrirNoticeModal('Para pagamento em credito, informe o numero de parcelas.')
          return
        }

        if (isCreditSelected.value && novoHonorario.value.paidValue >= novoHonorario.value.value) {
          abrirNoticeModal('No credito parcelado, o valor pago deve ser menor que o valor total do honorario.')
          return
        }

        if (!novoHonorario.value.status) {
          abrirNoticeModal('Selecione o status do honorario.')
          return
        }

        if (isInstallmentLocked.value) {
          novoHonorario.value.status = 'Pendente'
        }

        if (isImmediatePayment.value) {
          novoHonorario.value.status = 'Recebido'
        }

        if (isCreditSelected.value) {
          novoHonorario.value.status = 'Pendente'
        }

        if (novoHonorario.value.status === 'Recebido' && novoHonorario.value.paidValue < novoHonorario.value.value) {
          novoHonorario.value.paidValue = novoHonorario.value.value
          valorPagoFormatado.value = formatCurrency(novoHonorario.value.value)
        }

        const data = {
          ...novoHonorario.value,
          date: new Date(novoHonorario.value.date).toISOString(),
          installments: isCreditPaymentMethod(novoHonorario.value.paymentMethod || '')
            ? novoHonorario.value.installments
            : null
        }

        const response = await store.dispatch('cadastrarHonorario', data)

        if (isCreditSelected.value && novoHonorario.value.paidValue > 0 && response?.honorario?.id) {
          setUpfrontPaidValue(response.honorario.id, novoHonorario.value.paidValue)
        }

        abrirNoticeModal('Honorario cadastrado com sucesso!')
        resetForm()
        showModal.value = false
        await store.dispatch('loadHonorarios')
      } catch (error: any) {
        abrirNoticeModal(error.message || 'Erro ao cadastrar honorario')
      }
    }

    const abrirDeleteModal = (id: string) => {
      honorarioParaDeletar.value = id
      showDeleteModal.value = true
    }

    const fecharDeleteModal = () => {
      showDeleteModal.value = false
      honorarioParaDeletar.value = null
    }

    const confirmarDeleteHonorario = async () => {
      if (!honorarioParaDeletar.value) {
        return
      }

      const honorarioId = honorarioParaDeletar.value
      fecharDeleteModal()

      const finalizarExclusaoComSucesso = async () => {
        clearPaidInstallments(honorarioId)
        abrirNoticeModal('Honorario excluido com sucesso!')
        await Promise.allSettled([
          store.dispatch('loadHonorarios'),
          store.dispatch('loadClientes')
        ])
      }

      try {
        await store.dispatch('deletarHonorario', honorarioId)
        await finalizarExclusaoComSucesso()
      } catch (error: any) {
        const normalizedErrorMessage = typeof error?.message === 'string'
          ? normalizeErrorMessage(error.message)
          : ''

        if (normalizedErrorMessage.includes('honorario nao encontrado')) {
          await finalizarExclusaoComSucesso()
          return
        }

        abrirNoticeModal(error.message || 'Erro ao deletar honorario')
      }
    }

    const formatarData = (data: string | Date) => {
      const parsedDate = parseDate(data)
      return parsedDate ? parsedDate.toLocaleDateString('pt-BR') : '-'
    }

    watch([filtroStatus, filtroArea, somenteAtrasados], () => {
      paginaAtual.value = 1
    })

    watch(itensPorPagina, () => {
      paginaAtual.value = 1
    })

    watch(honorariosFiltrados, (items) => {
      const paginasDisponiveis = Math.max(Math.ceil(items.length / itensPorPagina.value), 1)
      if (paginaAtual.value > paginasDisponiveis) {
        paginaAtual.value = paginasDisponiveis
      }
    })

    onMounted(async () => {
      try {
        await Promise.all([
          store.dispatch('loadClientes'),
          store.dispatch('loadHonorarios')
        ])
      } catch (error: any) {
        abrirNoticeModal(error.message || 'Erro ao carregar dados')
      }
    })

    return {
      showModal,
      showDeleteModal,
      showNoticeModal,
      noticeMessage,
      filtroStatus,
      filtroArea,
      somenteAtrasados,
      buscarCliente,
      mostrarSugestoes,
      clientesFiltrados,
      parcelasDisponiveis,
      valorFormatado,
      valorPagoFormatado,
      novoHonorario,
      loading,
      isCreditSelected,
      isImmediatePayment,
      isInstallmentLocked,
      isStatusLocked,
      canEditProcessNumber,
      canEditLegalArea,
      canEditValue,
      canEditPaidValue,
      canEditDate,
      canEditPaymentMethod,
      canEditInstallments,
      canEditStatus,
      formularioCompleto,
      paginaAtual,
      itensPorPagina,
      totalPaginas,
      honorariosFiltrados,
      honorariosPaginados,
      formatCurrency,
      formatarData,
      formatarNumeroProcessoInput,
      formatarValorInput,
      formatarValorPagoInput,
      filtrarClientes,
      handleClienteInput,
      selecionarCliente,
      ajustarParcelas,
      salvarHonorario,
      cancelar,
      abrirDeleteModal,
      fecharDeleteModal,
      confirmarDeleteHonorario,
      fecharNoticeModal,
      toggleParcelas,
      isExpanded,
      alternarParcela,
      marcarHonorarioComoRecebido,
      marcarHonorarioComoPendente
    }
  }
})
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h1 {
  color: var(--text-primary);
}

.filters {
  display: flex;
  align-items: end;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  padding: 20px;
  background-color: var(--bg-secondary);
  border-radius: 10px;
}

.filters .form-group {
  margin-bottom: 0;
  min-width: 200px;
}

.toggle-filter {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary);
  font-size: 14px;
  padding-bottom: 10px;
}

.table-container {
  background-color: var(--bg-secondary);
  border-radius: 10px;
  overflow-x: auto;
  box-shadow: 0 2px 10px var(--shadow);
}

.table {
  min-width: 1120px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}

.status-badge.pendente {
  background-color: #ffc107;
  color: #000;
}

.status-badge.recebido {
  background-color: #28a745;
  color: white;
}

.actions-cell {
  white-space: nowrap;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid;
  padding: 5px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.btn-action + .btn-action {
  margin-left: 5px;
}

.btn-action.paid {
  border-color: #28a745;
  color: #28a745;
}

.btn-action.paid:hover {
  background-color: #28a745;
  color: white;
}

.btn-action.pending {
  border-color: #ffc107;
  color: #ffc107;
}

.btn-action.pending:hover {
  background-color: #ffc107;
  color: #000;
}

.btn-action.info {
  border-color: #5dade2;
  color: #5dade2;
}

.btn-action.info:hover {
  background-color: #5dade2;
  color: white;
}

.btn-action.delete {
  border-color: #f44336;
  color: #f44336;
}

.btn-action.delete:hover {
  background-color: #f44336;
  color: white;
}

.installment-summary {
  display: grid;
  gap: 4px;
}

.installment-meta {
  font-size: 12px;
  color: var(--text-secondary);
}

.installment-meta.overdue {
  color: #ffb75d;
  font-weight: 700;
}

.details-row td {
  padding: 0;
  border-bottom: none;
}

.details-panel {
  display: grid;
  gap: 16px;
  padding: 18px;
  background: color-mix(in srgb, var(--bg-primary) 70%, transparent);
}

.details-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.mini-card {
  padding: 14px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--bg-secondary) 88%, transparent);
  border: 1px solid color-mix(in srgb, var(--border-color) 80%, transparent);
}

.mini-card span {
  display: block;
  margin-bottom: 6px;
  color: var(--text-secondary);
  font-size: 12px;
  text-transform: uppercase;
}

.mini-card strong {
  color: var(--text-primary);
  font-size: 20px;
}

.mini-card.warning {
  border-color: rgba(255, 183, 93, 0.45);
}

.installments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}

.installment-card {
  display: grid;
  gap: 14px;
  padding: 16px;
  border-radius: 14px;
  background: color-mix(in srgb, var(--bg-secondary) 84%, transparent);
  border: 1px solid color-mix(in srgb, var(--border-color) 80%, transparent);
}

.installment-card.paid {
  border-color: rgba(52, 211, 153, 0.4);
}

.installment-card.overdue {
  border-color: rgba(255, 183, 93, 0.45);
  box-shadow: inset 0 0 0 1px rgba(255, 183, 93, 0.18);
}

.installment-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.installment-title {
  color: var(--text-primary);
  font-weight: 700;
}

.installment-date {
  margin-top: 4px;
  color: var(--text-secondary);
  font-size: 13px;
}

.installment-values {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.installment-values span {
  display: block;
  margin-bottom: 4px;
  color: var(--text-secondary);
  font-size: 12px;
}

.installment-values strong {
  color: var(--text-primary);
}

.installment-warning {
  color: #ffb75d;
  font-size: 13px;
  font-weight: 600;
}

.no-data {
  text-align: center;
  color: var(--text-secondary);
  font-style: italic;
  padding: 40px !important;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.field-help {
  display: block;
  margin-top: 8px;
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 1.4;
}

.btn-success {
  background: linear-gradient(135deg, #1f9d55, #28b463);
  color: white;
  border: none;
}

.btn-success:hover {
  background: linear-gradient(135deg, #18874a, #229954);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.modal-content h2 {
  color: var(--text-primary);
  margin-bottom: 20px;
  text-align: center;
}

.autocomplete-container {
  position: relative;
}

.suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-top: none;
  border-radius: 0 0 5px 5px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 10px var(--shadow);
}

.suggestion-item {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-primary);
  transition: background-color 0.2s ease;
}

.suggestion-item:hover {
  background-color: var(--primary-color);
  color: white;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.notice-modal {
  max-width: 460px;
  text-align: left;
  background: color-mix(in srgb, var(--bg-secondary) 94%, var(--bg-primary));
  border: 1px solid color-mix(in srgb, #4a91ff 38%, var(--border-color));
  box-shadow: 0 16px 42px color-mix(in srgb, #001946 28%, transparent);
}

.notice-modal h2 {
  color: color-mix(in srgb, #6aa8ff 72%, var(--text-primary));
  margin-bottom: 12px;
  text-align: left;
}

.notice-modal p {
  color: var(--text-primary);
  line-height: 1.5;
  opacity: 0.92;
}

@media (max-width: 768px) {
  .filters,
  .page-header,
  .installment-head,
  .form-actions,
  .modal-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .filters .form-group {
    min-width: 100%;
  }

  .toggle-filter {
    padding-bottom: 0;
  }

  .table {
    min-width: 980px;
  }

  .installment-values {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .filters {
    padding: 16px;
  }

  .table {
    min-width: 900px;
  }

  .details-panel {
    padding: 14px;
  }
}
</style>
